var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c("div", { staticClass: "page" }, [
      _c(
        "div",
        { staticClass: "main-container", attrs: { id: "main-container" } },
        [
          _c("div", { attrs: { id: "boxNew" } }, [
            _c("div", { staticClass: "boxD" }, [
              _c("div", { staticClass: "inBox" }, [
                _c("h4", [
                  _c("img", { attrs: { src: _vm.inteUrl, alt: "" } }),
                  _vm._v(" "),
                  _c("span", [_vm._v("可用积分")])
                ]),
                _vm._v(" "),
                _c("h5", [_vm._v(_vm._s(_vm.logDetails.total))])
              ]),
              _vm._v(" "),
              _vm._m(0)
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "box" }, [
              _c("div", { staticClass: "boxList" }, [
                _vm.listShow
                  ? _c(
                      "div",
                      { staticClass: "aaBox" },
                      [
                        _c(
                          "van-list",
                          {
                            attrs: { finished: _vm.finished },
                            on: { load: _vm.onLoad },
                            model: {
                              value: _vm.ploading,
                              callback: function($$v) {
                                _vm.ploading = $$v
                              },
                              expression: "ploading"
                            }
                          },
                          _vm._l(_vm.list, function(item) {
                            return _c(
                              "div",
                              { key: item.id, staticClass: "list" },
                              [
                                _c(
                                  "van-row",
                                  [
                                    _c("van-col", { attrs: { span: "16" } }, [
                                      _c("p", { staticClass: "p1" }, [
                                        _vm._v(_vm._s(item.typeStr))
                                      ]),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "p2" }, [
                                        _vm._v(_vm._s(item.createTime))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "van-col",
                                      {
                                        staticClass: "pointCol",
                                        attrs: { span: "8" }
                                      },
                                      [_vm._v(_vm._s(item.pointStr))]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.listShow
                  ? _c("div", { staticClass: "listBoxStyle" }, [
                      _c("img", { attrs: { src: _vm.noJfUrl, alt: "" } }),
                      _vm._v(" "),
                      _c("p", [_vm._v("暂无积分哦！")])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "divBottomStyle" })
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mx" }, [_c("span", [_vm._v("积分明细")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }